<main class="contact-page">
  <section class="contact-hero" aria-label="Claro empresas">
    <picture>
      <source
        media="(max-width: 767.98px)"
        srcset="assets/websummit/banner-claro-empresas-mobile.png"
        width="828"
        height="1042"
      />
      <img
        class="contact-hero__banner"
        src="assets/websummit/banner-claro-empresas.png"
        alt="Claro empresas"
        width="2880"
        height="750"
        decoding="async"
        fetchpriority="high"
      />
    </picture>
  </section>

  <section id="contato" class="contact-lead" aria-labelledby="contact-heading">
    <div class="contact-lead__wrap">
      <div class="contact-card">
        <h1 id="contact-heading" class="contact-card__title">
          Solicite o atendimento de um dos nossos consultores
        </h1>

        <form
          class="contact-card__form"
          [formGroup]="form"
          (ngSubmit)="onSubmit()"
          novalidate
          [hidden]="showSuccess"
        >
          <div class="contact-card__row contact-card__row--cnpj-nome">
            <label class="contact-field">
              <span class="contact-field__label">CNPJ <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('cnpj')"
                type="text"
                formControlName="cnpj"
                inputmode="numeric"
                autocomplete="off"
                placeholder="__.___.___/____-__"
                (input)="onCnpjInput($event)"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('cnpj')">
                {{ showError('cnpj') ? errorMessage('cnpj') : '' }}
              </span>
            </label>
            <label class="contact-field">
              <span class="contact-field__label">Nome <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('nome')"
                type="text"
                formControlName="nome"
                autocomplete="name"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('nome')">
                {{ showError('nome') ? errorMessage('nome') : '' }}
              </span>
            </label>
          </div>

          <div class="contact-card__row contact-card__row--email-phone">
            <label class="contact-field">
              <span class="contact-field__label">E-mail <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('email')"
                type="email"
                formControlName="email"
                autocomplete="email"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('email')">
                {{ showError('email') ? errorMessage('email') : '' }}
              </span>
            </label>
            <label class="contact-field">
              <span class="contact-field__label">Telefone <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('telefone')"
                type="tel"
                formControlName="telefone"
                autocomplete="tel"
                placeholder="(__) ____-____"
                (input)="onPhoneInput($event, 'telefone')"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('telefone')">
                {{ showError('telefone') ? errorMessage('telefone') : '' }}
              </span>
            </label>
          </div>

          <div class="contact-card__row contact-card__row--thirds">
            <label class="contact-field">
              <span class="contact-field__label">Telefone 2</span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('telefone2')"
                type="tel"
                formControlName="telefone2"
                autocomplete="tel"
                placeholder="(__) ____-____"
                (input)="onPhoneInput($event, 'telefone2')"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('telefone2')">
                {{ showError('telefone2') ? errorMessage('telefone2') : '' }}
              </span>
            </label>
            <label class="contact-field">
              <span class="contact-field__label">CEP <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('cep')"
                type="text"
                formControlName="cep"
                inputmode="numeric"
                autocomplete="postal-code"
                placeholder="_____-___"
                (input)="onCepInput($event)"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('cep')">
                {{ showError('cep') ? errorMessage('cep') : '' }}
              </span>
            </label>
            <label class="contact-field">
              <span class="contact-field__label">Já é cliente Claro? <span class="contact-field__req">*</span></span>
              <select
                class="contact-field__input contact-field__select"
                [class.contact-field__input--invalid]="showError('clienteClaro')"
                formControlName="clienteClaro"
              >
                <option value="">Selecione</option>
                <option value="sim">Sim</option>
                <option value="nao">Não</option>
              </select>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('clienteClaro')">
                {{ showError('clienteClaro') ? errorMessage('clienteClaro') : '' }}
              </span>
            </label>
          </div>

          <div class="contact-card__row contact-card__row--full">
            <label class="contact-field">
              <span class="contact-field__label">Empresa <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('empresa')"
                type="text"
                formControlName="empresa"
                autocomplete="organization"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('empresa')">
                {{ showError('empresa') ? errorMessage('empresa') : '' }}
              </span>
            </label>
          </div>

          <div class="contact-card__actions">
            <button
              type="submit"
              class="contact-btn contact-btn--primary"
              [disabled]="!canSubmit"
              [attr.aria-disabled]="!canSubmit"
              [attr.aria-busy]="isSubmitting"
            >
              {{ isSubmitting ? 'Enviando...' : 'Enviar' }}
            </button>
            <button
              type="button"
              class="contact-btn contact-btn--ghost"
              [disabled]="!canClear || isSubmitting"
              [attr.aria-disabled]="!canClear || isSubmitting"
              (click)="onClear()"
            >
              Limpar
            </button>
          </div>

          <p class="contact-card__legal">
            Ao enviar este formulário, você concorda com o tratamento dos seus dados pessoais conforme a
            Política de Privacidade da Claro.
          </p>
        </form>

        @if (showSuccess) {
          <p class="contact-card__success" role="status">
            Recebemos seus dados. Em breve um consultor entrará em contato.
          </p>
        }
      </div>
    </div>
  </section>
</main>

<footer class="contact-site-footer" role="contentinfo">
  <div class="contact-site-footer__inner">
    <img
      class="contact-site-footer__logo"
      src="https://mondrian.claro.com.br/brands/horizontal/default/claro-empresas.svg"
      alt="Claro empresas"
      width="86"
      height="28"
    />
    <div class="contact-site-footer__copy">
      <span class="contact-site-footer__line">Copyright © {{ currentYear }}</span>
      <span class="contact-site-footer__line">Todos os direitos reservados.</span>
    </div>
  </div>
</footer>
